(() => {
  if (window.__spRefinedFooterCurrency) return;
  window.__spRefinedFooterCurrency = true;

  const selector = '[data-sp-currency-selector]';

  const closeSelector = (root, returnFocus = false) => {
    const toggle = root.querySelector('[data-sp-currency-toggle]');
    const menu = root.querySelector('[data-sp-currency-menu]');
    if (!toggle || !menu) return;

    toggle.setAttribute('aria-expanded', 'false');
    menu.hidden = true;
    if (returnFocus) toggle.focus();
  };

  const closeAll = (except) => {
    document.querySelectorAll(selector).forEach((root) => {
      if (root !== except) closeSelector(root);
    });
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-sp-currency-toggle]');
    if (toggle) {
      const root = toggle.closest(selector);
      const menu = root && root.querySelector('[data-sp-currency-menu]');
      if (!root || !menu) return;

      const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      closeAll(root);
      toggle.setAttribute('aria-expanded', String(willOpen));
      menu.hidden = !willOpen;

      if (willOpen) {
        const selected = menu.querySelector('[role="option"][aria-selected="true"]');
        (selected || menu.querySelector('[role="option"]'))?.focus();
      }
      return;
    }

    const option = event.target.closest('[data-sp-country-option]');
    if (option) {
      const root = option.closest(selector);
      const form = root && root.querySelector('form');
      const input = root && root.querySelector('[data-sp-country-input]');
      if (!root || !form || !input) return;

      input.value = option.dataset.spCountryOption;
      closeSelector(root);
      form.submit();
      return;
    }

    if (!event.target.closest(selector)) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const root = event.target.closest(selector);
    if (root) closeSelector(root, true);
  });
})();
